import { render } from "./ChapterPagePart1Content.vue?vue&type=template&id=5eb79e74&scoped=true"
import script from "./ChapterPagePart1Content.vue?vue&type=script&lang=js"
export * from "./ChapterPagePart1Content.vue?vue&type=script&lang=js"

import "./ChapterPagePart1Content.vue?vue&type=style&index=0&id=5eb79e74&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb79e74"]])

export default __exports__